import { colors } from "assets/constants";

const toastColorIcon = (type?: string): { icon: IconT; color: string } => {
  switch (type) {
    case "success":
      return {
        icon: { name: "check-circle", color: colors.success },
        color: colors.success,
      };

    case "error":
      return {
        icon: { name: "alert-circle", color: colors.danger },
        color: colors.danger,
      };

    case "warning":
      return {
        icon: { name: "alert-triangle", color: colors.warning },
        color: colors.warning,
      };

    case "info":
      return { icon: { name: "info", color: colors.info }, color: colors.info };

    default:
      return { icon: { name: "info", color: colors.info }, color: colors.info };
  }
};

export default toastColorIcon;
